import { KompisElementRegistry } from '@inter-ikea-kompis/web-component';
import { GlobalCacheStore } from '@inter-ikea-kompis/utilities';
import { HyperlinkTargetEnum } from '@inter-ikea-kompis/component-hyperlink';
import './components/toast/Toast.js';
import Toast from './components/toast/Toast.js';
/**
 * This class is used for calculating the hight of toasts and manage hover events.
 */
class ToastManager {
    /**
     * @param options Argument holder object.
     * @param options.theme Theme.
     * @param options.cacheStore GlobalCacheStore.
     */
    constructor({ theme, cacheStore = new GlobalCacheStore() }) {
        this.theme = theme;
        this.store = cacheStore.getStore('ToastManagerToast');
    }
    /**
     * @param options ...
     * @param options.label The label for the Toast.
     * @param options.actionLabel A label for the action.
     * @param options.actionHref An url for the action (e.g. "https://www.ikea.com").
     * @param options.actionTarget Target for hyperlink. The same as for a <a>-tag.
     * @param options.onActionClick Called when user clicks on the action in the toast.
     */
    showToast(options) {
        const toastElement = this.getToastElement();
        toastElement.label = options.label;
        toastElement.actionLabel = options.actionLabel ?? null;
        toastElement.actionHref = options.actionHref ?? null;
        toastElement.actionTarget = options.actionTarget ?? HyperlinkTargetEnum.blank;
        toastElement.visible = true;
        if (options.onActionClick) {
            toastElement.addEventListener('actionClick', options.onActionClick);
        }
    }
    hideToast() {
        const toastElement = this.store.get('toast');
        if (toastElement?.visible) {
            toastElement.visible = false;
        }
    }
    /**
     * @returns A toast element.
     */
    getToastElement() {
        const currentToastElement = this.store.get('toast');
        if (currentToastElement?.visible) {
            currentToastElement.animateChange();
            currentToastElement.startTimer();
            return currentToastElement;
        }
        const toastElement = this.createNewToastElement();
        this.store.set('toast', toastElement);
        document.body.appendChild(toastElement);
        return toastElement;
    }
    /**
     * Creates a new toast element hand handle life cycle for this.
     */
    createNewToastElement() {
        this.constructor.customElements.define('kompis-toast', Toast);
        const toastElement = document.createElement(this.constructor.customElements.getInternalName('kompis-toast'));
        toastElement.addEventListener('close', () => {
            this.store.delete('toast');
            toastElement.visible = false;
        });
        toastElement.addEventListener('animationEnd', () => {
            if (!toastElement.visible) {
                toastElement.remove();
            }
        });
        toastElement.theme = this.theme;
        return toastElement;
    }
}
ToastManager.customElements = new KompisElementRegistry();
export default ToastManager;
//# sourceMappingURL=ToastManager.js.map